import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "@/i18n";
import { langFromPath } from "@/hooks/useLanguage";

export function useLanguageSync() {
  const location = useLocation();

  useEffect(() => {
    const lang = langFromPath(location.pathname);
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [location.pathname]);
}